import { TObject } from '@shared/types/fetch-data';

export function isObject(obj: TObject) {
  return obj !== null && typeof obj === 'object';
}
